var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.randPackage != null)?_c('div',{staticClass:"card text-left"},[_c('package-card',{attrs:{"pack":_vm.randPackage}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }